import OrganizationFormContainer from './organization_form_container';

const OrganizationForm = OrganizationFormContainer;
export default OrganizationForm;
